import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

function AuthRedirectScreen() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <Spin indicator={<LoadingOutlined spin />} size="large" />
      <p className="text-center text-gray-600">Signing you in...</p>
    </div>
  );
}

export default AuthRedirectScreen;
